export const SOCIAL_SHARE = {
  twitter: {
    icon: 'social/twitter',
    shareUrl: 'https://twitter.com/intent/tweet?url='
  },
  telegram: {
    icon: 'social/telegram',
    shareUrl: 'https://t.me/share/url?url='
  },
  linkedin: {
    icon: 'social/linkedin',
    shareUrl: 'https://www.linkedin.com/sharing/share-offsite/?url='
  },
  facebook: {
    icon: 'social/facebook',
    shareUrl: 'https://www.facebook.com/sharer/sharer.php?u='
  }
}

